import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  {
    title: 'Demo',
    isLink: false,
  },
  {
    title: 'Clients',
    isLink: false,
  },
];

const Title: PageTitle = {
  title: 'Clients',
};

export { Breadcrumbs, Title };